import { Injectable } from '@angular/core';
import { ContentsService, CatalogPage } from '@vestiaire/api-sdk-angular';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RoutingService } from '@app/core/services/routing.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CatalogPageResolver implements Resolve<CatalogPage> {
  constructor(private contentsService: ContentsService, private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CatalogPage> {
    let url = this.routingService.buildPath(route.url);
    const match = this.routingService.getCatalogPaginationMatch(url);
    if (match) {
      const [, path, page] = match;
      url = path;

      // Hardcoded max page: 17
      if (Number(page) === 1 || Number(page) > 17) {
        this.routingService.redirectTo(url);
        return null;
      }
    }

    return this.contentsService.listCatalogPages(url).pipe(
      map(res => {
        if (url !== res.data.path) {
          this.routingService.redirectTo(res.data.path, route.queryParams);
          return null;
        }

        return res.data;
      }),
      catchError(err => {
        this.routingService.redirectError(err.status, state.url);
        return of(null);
      })
    );
  }
}
